import { connect } from 'react-redux'
import ArchivedTable from './archived-table'
import { getInvitationsList } from '../../../../../stores/archived-invitations/archived-invitations.selectors'

const mapStateToProps = state => ({
  invitations: getInvitationsList(state)
})

export default connect(mapStateToProps, null)(ArchivedTable)
